<template>
  <div class="themed-slider">
    <input
      :id="id"
      type="range"
      :value="value"
      :min="min"
      :max="max"
      :step="step"
      :disabled="disabled"
      :class="sliderClasses"
      :aria-valuemin="min"
      :aria-valuemax="max"
      :aria-valuenow="value"
      v-bind="$attrs"
      @input="handleInput"
      @change="$emit('change', $event.target.value)"
    />
    <div v-if="showValue" class="themed-slider__value">
      {{ value }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'ThemedSlider',
  inheritAttrs: false,
  props: {
    id: {
      type: String,
      default: null
    },
    value: {
      type: [String, Number],
      default: 0
    },
    min: {
      type: [String, Number],
      default: 0
    },
    max: {
      type: [String, Number],
      default: 100
    },
    step: {
      type: [String, Number],
      default: 1
    },
    disabled: {
      type: Boolean,
      default: false
    },
    showValue: {
      type: Boolean,
      default: true
    },
    error: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    sliderClasses() {
      return [
        'themed-slider__input',
        {
          'themed-slider__input--error': this.error,
          'themed-slider__input--disabled': this.disabled
        }
      ];
    }
  },
  methods: {
    handleInput(event) {
      const value = event.target.value;
      this.$emit('input', value);
    }
  }
}
</script>

<style lang="less">
@import '../../../../less/theme/v1/components/themed-slider.less';
</style>
